import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { PaymentsPaginatorInterface } from '../models/payments.paginator.interface';
import { PaymentScheduleInterface } from '../models/payment.schedule.interface';
import { WalletPaginatorInterface } from "../models/wallet.paginator.interface";

@Injectable()
export class PaymentsService {

  constructor(
      private apiService: ApiService
  ) {}

  /**
   * Get payments list
   * @param selectedPage
   * @param totalItemsPerPage
   */
  get(selectedPage: number, totalItemsPerPage: number): Observable<PaymentsPaginatorInterface> {
    return this.apiService.get('payments/' + selectedPage + '/' + totalItemsPerPage);
  }

  /**
   * Get wallet list
   */
  getWallet(selectedPage: number, totalItemsPerPage: number): Observable<WalletPaginatorInterface> {
    return this.apiService.get('customer/wallet/' + selectedPage + '/' + totalItemsPerPage);
  }

  /**
   * Get payments schedule
   */
  getSchedule(period: number, items: number): Observable<Array<PaymentScheduleInterface>> {
    return this.apiService.get('payments-schedule/' + period + '/' + items);
  }

  /**
   * @param paymentId
   * @param path
   */
  downloadCreditFile(paymentId: number, path: string): Observable<Blob> {
    return this.apiService.downloadFile('file/credit/' + paymentId + '/' + path);
  }

  /**
   * @param hash
   */
  downloadSepa(hash: string): Observable<Blob> {
    const data = {
      fileTypeSlug: 'sepa_mandate',
      extra: hash
    };
    return this.apiService.getFile('file/download', data);
  }

  downloadInvoiceCredit(billId: number, fileTypeSlug: string): Observable<Blob> {
    const data = {
      fileTypeSlug,
      extra: billId.toString()
    };
    return this.apiService.getFile('file/download', data);
  }
}
